export default __webpack_public_path__ + "static/media/chart_icon.161c2dcb.svg";